import script from "./confirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./confirm.vue?vue&type=script&lang=ts&setup=true"

import "./confirm.vue?vue&type=style&index=0&id=4daba80c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4daba80c"]])

export default __exports__